export default __webpack_public_path__ + "static/1857-6988687629984b997a68c618ebc002e8.gif";